import { callGetApiv2, callPostApiv2, callPutApiv2 } from "./api";
import { uploadImageFromFormData } from "../Helpers/uploadViaPresign";

export async function getFeaturedProduct(id, moduleName) {
    return callGetApiv2(`featured-product/${moduleName}/${id}/${false}`);
}

export async function uploadImage(data) {
    // data is FormData with an "image" field (legacy multipart shape).
    // Routed through api-v2 presign + direct-to-S3 PUT; response shape
    // matches the legacy multipart envelope so consumers don't change.
    return uploadImageFromFormData(data);
}

export async function updateStatus(postData) {
    return callPutApiv2("utils/update-status/", postData);
}

export async function validateTwilioPhoneNumber(postData) {
    return callPostApiv2("utils/validate-twilio-phone-number", postData);
}